import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=38a4dd5f&"
import script from "./AlbumList.vue?vue&type=script&lang=js&"
export * from "./AlbumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports